module.exports = __webpack_public_path__ + "img/video-segment.e631f825.png";